import styles from "@/styles/Video.module.scss";
import AgeRestriction from "./AgeRestriction";
import AppKick from "./AppKick";
import DvrLive from "./DvrLive";
import EntitlementConfirm from "./EntitlementConfirm";
import LiveBefore from "./LiveBefore";
import NeedLogin from "./NeedLogin";
import NextEpisode from "./NextEpisode";
import NoEntitled from "./NoEntitled";
import OverlayError from "./OverlayError";
import ResumeSelect from "./ResumeSelect";
import SuggestApp from "./SuggestApp";
import { useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function VideoOverlay(_ref) {
  var watch = _ref.watch,
      state = _ref.state,
      error = _ref.error,
      poster = _ref.poster;
  var overlayRef = useRef();
  if (!state.overlay && !error) return null;
  return /*#__PURE__*/_jsxs("div", {
    className: styles.overlay,
    ref: overlayRef,
    children: [state.reason === "needlogin" && /*#__PURE__*/_jsx(NeedLogin, {
      watch: watch
    }), state.reason === "needlogin_and_contract" && /*#__PURE__*/_jsx(NeedLogin, {
      withContract: true,
      watch: watch
    }), state.reason === "entitlement_confirm" && /*#__PURE__*/_jsx(EntitlementConfirm, {
      state: state
    }), state.reason === "geolocation" && /*#__PURE__*/_jsx(OverlayError, {
      message: state.error.message,
      error: state.error
    }), state.reason === "suggest_app" && /*#__PURE__*/_jsx(SuggestApp, {
      watch: watch,
      state: state
    }), state.reason === "resume" && /*#__PURE__*/_jsx(ResumeSelect, {
      state: state
    }), state.reason === "live_before" && /*#__PURE__*/_jsx(LiveBefore, {
      watch: watch,
      state: state
    }), state.reason === "dvr_live" && /*#__PURE__*/_jsx(DvrLive, {
      state: state
    }), state.reason === "appkick" && /*#__PURE__*/_jsx(AppKick, {
      watch: watch
    }), state.reason === "rating" && /*#__PURE__*/_jsx(AgeRestriction, {
      watch: watch
    }), state.reason === "next_episode" && /*#__PURE__*/_jsx(NextEpisode, {
      watch: watch,
      state: state
    }), state.reason === "playback_error" && /*#__PURE__*/_jsxs(_Fragment, {
      children: [state.error.reason == "not_delivery_started" && /*#__PURE__*/_jsx(OverlayError, {
        poster: poster,
        error: state.error
      }), state.error.reason == "not_entitled" && /*#__PURE__*/_jsx(NoEntitled, {
        watch: watch
      }), !["not_entitled", "not_delivery_started"].includes(state.error.reason) && /*#__PURE__*/_jsx(OverlayError, {
        error: state.error
      })]
    }), state.reason === "error" && /*#__PURE__*/_jsx(OverlayError, {
      error: state.error
    }), error && /*#__PURE__*/_jsx(OverlayError, {
      error: error
    })]
  });
}